import React, { useState, useEffect, HtmlHTMLAttributes } from 'react'
import cl from 'classnames'
import Meta from 'types/Meta'
import PaginationService from '../../../utils/PaginationService'

import { IoMdArrowRoundBack, IoMdArrowRoundForward } from 'react-icons/io'
import Link from 'next/link'
import { ButtonMovePage } from './button-move-page'
import styles from './styles.module.scss'
import { useRouter } from 'next/router'

type PaginationProps = HtmlHTMLAttributes<HTMLDivElement> &
  Pick<Meta, 'currentPage' | 'pageSize' | 'total'> & { queryParams?: any }

export const Pagination: React.FunctionComponent<PaginationProps> = ({
  currentPage,
  pageSize,
  total,
  queryParams,
  ...rest
}) => {
  const [pagination, setPagination] = useState(['1'])
  const totalPages = Math.ceil(total / pageSize)

  const router = useRouter()
  const { page, ...restQuery } = router.query

  useEffect(() => {
    setPagination(PaginationService.execute(totalPages, currentPage))
  }, [totalPages, page])

  return (
    <div className={styles.container} {...rest}>
      <div className={styles.main}>
        <ButtonMovePage
          isBlock={currentPage !== 1}
          page={currentPage - 1}
          queryParams={restQuery}
        >
          <IoMdArrowRoundBack />
        </ButtonMovePage>

        {pagination.map((item, index) =>
          item === '...' ? (
            <span className={styles.numberPagination} key={index}>
              ...
            </span>
          ) : (
            <Link
              href={{
                query: { page: item, ...restQuery }
              }}
              key={index}
              className={cl(styles.numberPagination, {
                underline: currentPage === Number(item)
              })}
            >
              {item}
            </Link>
          )
        )}
        <ButtonMovePage
          isBlock={currentPage !== totalPages}
          page={currentPage + 1}
          queryParams={restQuery}
        >
          <IoMdArrowRoundForward />
        </ButtonMovePage>
      </div>
    </div>
  )
}
